"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCsp = void 0;
var configService_1 = require("./configService");
var SELF = "'self'";
var UNSAFE_INLINE = "'unsafe-inline'";
var UNSAFE_EVAL = "'unsafe-eval'";
var BLOB = 'blob:';
var DATA = 'data:';
var STAR = '*';
var INTEG = process.env.INTEG && process.env.INTEG !== 'false';
var defaultSrc = [SELF, BLOB, UNSAFE_INLINE, 'http://*.googlesyndication.com', 'http://*.criteo.com', 'https://jahia7.babel.fr'];
var imgSrc = [BLOB, STAR, DATA];
var fontSrc = [STAR, DATA];
var scriptSrc = [
    SELF,
    BLOB,
    UNSAFE_INLINE,
    UNSAFE_EVAL,
    'https://*.fr.shopping.rakuten.com',
    'https://fr.shopping.rakuten.com',
    'http://*.fr.shopping.rakuten.com',
    'https://pmcdn.priceminister.com',
    'https://pmcdn.staticpmrk.com',
    'https://connect.facebook.net',
    'https://maps.google.com',
    'https://www.googletagservices.com',
    'http://www.googletagservices.com',
    'http://d1m6l9dfulcyw7.cloudfront.net',
    'https://ajax.googleapis.com',
    'http://tag.aticdn.net',
    'https://securepubads.g.doubleclick.net',
    'http://*.criteo.net',
    'http://*.criteo.com',
    'http://*.stormiq.com',
    'https://*.googlesyndication.com',
    'http://*.googlesyndication.com',
    'https://maps.googleapis.com',
    'http://*.rubiconproject.com',
    'http://cdn.tinyclues.com',
    'https://adservice.google.fr',
    'https://adservice.google.com',
    'https://www.googletagmanager.com',
    'https://cdnjs.cloudflare.com',
    'http://t.contentsquare.net',
    'https://t.contentsquare.net',
    'http://js.rmtag.com',
    'http://www.google-analytics.com',
    'http://bat.bing.com',
    'http://nxtck.com',
    'http://r.r10s.jp',
    'http://js.sddan.com',
    'http://www.googleadservices.com',
    'http://mastertag.effiliation.com',
    'http://www.rtmlb.com',
    'http://mmtro.com',
    'http://js.avads.net',
    "".concat(configService_1.serverRuntimeConfig.kmlEndpoint),
    'https://jahia7.babel.fr',
    'https://www.google.com',
    'https://sdk.privacy-center.org',
    'https://sdk-gcp.privacy-center.org',
    'https://*.wlscripts.net',
    'https://d32106rlhdcogo.cloudfront.net',
    'https://d3dh5c7rwzliwm.cloudfront.net',
    'https://dgf0rw7orw6vf.cloudfront.net',
    'http://www.personalicanvas.com',
    'https://www.personalicanvas.com',
    'https://*.sendbird.com',
    'wss://*.sendbird.com',
    'https://*.xiti.com',
    'https://*.kameleoon.eu',
    'https://*.kameleoon.com',
    'https://restapi.surveygizmo.com',
    'https://js.datadome.co',
    'https://*.processout.com',
    'https://*.marqeta.com',
];
var connectSrc = [
    SELF,
    'https://*.fr.shopping.rakuten.com',
    'https://fr.shopping.rakuten.com',
    'http://*.fr.shopping.rakuten.com',
    'https://*.priceminister.com',
    'http://*.priceminister.com',
    'https://pmcdn.staticpmrk.com ',
    'http://*.criteo.com',
    'https://*.contentsquare.net',
    'https://clues.tinyclues.com',
    'https://securepubads.g.doubleclick.net',
    'https://*.googlesyndication.com',
    'https://*.adsafeprotected.com',
    'https://jahia7.babel.fr',
    'https://api.privacy-center.org',
    'http://*.personali.com',
    'https://*.personali.com',
    'https://*.sendbird.com',
    'wss://*.sendbird.com',
    'https://*.xiti.com',
    'https://*.kameleoon.eu',
    'https://*.kameleoon.com',
    'https://restapi.surveygizmo.com',
    'https://api-js.datadome.co',
    'https://*.processout.com',
    'https://*.marqeta.com',
];
var styleSrc = [
    SELF,
    BLOB,
    UNSAFE_INLINE,
    'https://*.fr.shopping.rakuten.com',
    'https://fr.shopping.rakuten.com',
    'https://pmcdn.priceminister.com',
    'https://pmcdn.staticpmrk.com',
    'https://fonts.googleapis.com',
    'https://jahia7.babel.fr',
    'https://cdnjs.cloudflare.com',
];
var childSrc = ['http://*.criteo.com', 'http://*.googlesyndication.com'];
var frameSrc = [
    'https://*.solution.weborama.fr',
    'https://*.commander1.com',
    'https://*.googlesyndication.com',
    'http://*.criteo.com',
    'http://tpc.googlesyndication.com',
    'https://www.google.com',
    'http://www.googletagservices.com/',
    'https://geo.captcha-delivery.com/',
    'https://*.processout.com',
    'https://*.marqeta.com',
];
var workerSrc = [BLOB, 'https://*.fr.shopping.rakuten.com'];
if (INTEG) {
    scriptSrc.push('https://pmcdn.pminteg.fr');
    scriptSrc.push('https://pmcdn.pminteg1.fr');
    scriptSrc.push('https://pmcdn.pminteg2.fr');
    connectSrc.push('https://pmcdn.pminteg.fr');
    connectSrc.push('https://pmcdn.pminteg1.fr');
    connectSrc.push('https://pmcdn.pminteg2.fr');
    styleSrc.push('https://pmcdn.pminteg.fr');
    styleSrc.push('https://pmcdn.pminteg1.fr');
    styleSrc.push('https://pmcdn.pminteg2.fr');
}
var csp = {
    'default-src': process.env.CSP_DEFAULT_SRC || defaultSrc.join(' '),
    'img-src': process.env.CSP_IMG_SRC || imgSrc.join(' '),
    'font-src': process.env.CSP_FONT_SRC || fontSrc.join(' '),
    'script-src': process.env.CSP_SCRIPT_SRC || scriptSrc.join(' '),
    'connect-src': process.env.CSP_CONNECT_SRC || connectSrc.join(' '),
    'style-src': process.env.CSP_STYLE_SRC || styleSrc.join(' '),
    'child-src': process.env.CSP_CHILD_SRC || childSrc.join(' '),
    'frame-src': process.env.CSP_FRAME_SRC || frameSrc.join(' '),
    'worker-src': process.env.CSP_WORKER_SRC || workerSrc.join(' '),
};
if (process.env.CSP_MEDIA_SRC) {
    csp['media-src'] = process.env.CSP_MEDIA_SRC;
}
if (process.env.CSP_OBJECT_SRC) {
    csp['object-src'] = process.env.CSP_OBJECT_SRC;
}
if (process.env.CSP_PREFETCH_SRC) {
    csp['prefetch-src'] = process.env.CSP_PREFETCH_SRC;
}
if (process.env.CSP_BASE_URI) {
    csp['base-uri'] = process.env.CSP_BASE_URI;
}
function getCsp() {
    var parts = csp['connect-src'].split(/^s/).filter(function (value) { return value; });
    if (configService_1.serverRuntimeConfig.apiUrl &&
        configService_1.serverRuntimeConfig.apiUrl !== '/' &&
        typeof parts.find(function (v) { return configService_1.serverRuntimeConfig.apiUrl === v; }) === 'undefined') {
        parts.push(configService_1.serverRuntimeConfig.apiUrl);
    }
    if (configService_1.serverRuntimeConfig.apiVis && typeof parts.find(function (v) { return configService_1.serverRuntimeConfig.apiVis === v; }) === 'undefined') {
        parts.push(configService_1.serverRuntimeConfig.apiVis);
    }
    if (configService_1.serverRuntimeConfig.apiBuyer && typeof parts.find(function (v) { return configService_1.serverRuntimeConfig.apiBuyer === v; }) === 'undefined') {
        parts.push(configService_1.serverRuntimeConfig.apiBuyer);
    }
    if (configService_1.serverRuntimeConfig.apiSeller && typeof parts.find(function (v) { return configService_1.serverRuntimeConfig.apiSeller === v; }) === 'undefined') {
        parts.push(configService_1.serverRuntimeConfig.apiSeller);
    }
    if (configService_1.serverRuntimeConfig.apiMerch && typeof parts.find(function (v) { return configService_1.serverRuntimeConfig.apiMerch === v; }) === 'undefined') {
        parts.push(configService_1.serverRuntimeConfig.apiMerch);
    }
    var result = Object.assign({}, csp);
    result['connect-src'] = parts.join(' ');
    return Object.keys(result).map(function (key) { return "".concat(key, " ").concat(result[key]); }).join(';');
}
exports.getCsp = getCsp;
